module.exports = __webpack_public_path__ + "img/stage_drachenkopf.0c65e8ee.jpg";